import React from 'react';
import { useViewportScroll, useTransform } from 'framer-motion6';
import {
  TopLeftFeather,
  TopRightFeather,
  BottomRightFeather,
  MiddleFeather,
  RightMiddleFeather,
  MobileTopFeather,
  MobileBottomFeather
} from './styled';

const Feathers = () => {
  const { scrollY } = useViewportScroll();

  const mappedTimings = [...Array(80)].map((num, i) => {
    return 1000 + i * 150;
  });

  const mappedRotation = (from, to) => {
    return mappedTimings?.map((el, i) => {
      if (i % 2 === 0) {
        return from;
      }
      return to;
    });
  };

  const useGetRotation = (from, to) => {
    return useTransform(scrollY, [...mappedTimings], [...mappedRotation(from, to)]);
  };

  return (
    <>
      <TopLeftFeather style={{ rotate: useGetRotation(35, 25) }} />
      <TopRightFeather style={{ rotate: useGetRotation(157, 165) }} />
      <BottomRightFeather style={{ rotate: useGetRotation(-117, -130) }} />
      <MiddleFeather style={{ rotate: useGetRotation(119, 130) }} />
      <RightMiddleFeather style={{ rotate: useGetRotation(-47, -60) }} />
      <MobileTopFeather style={{ rotate: useGetRotation(-121, -115) }} />
      <MobileBottomFeather style={{ rotate: useGetRotation(-226, -220) }} />
    </>
  );
};

export default Feathers;
